<template>
  <div>
    <ModuleHeader>Exportar Tickets</ModuleHeader>
    <v-overlay :value="loadingData">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <v-row>
      <v-col md="12" cols="12">
        <v-card>
          <v-card-text>
            <p class="text-subtitle-1">Filtros</p>
            <v-row>
              <v-col md="3" cols="12" class="input">
                <label>Fecha inicial</label>
                <Datepicker
                  @selected="selectDate"
                  :value="input_date.format('MM/DD/YYYY')"
                ></Datepicker>
              </v-col>
              <v-col md="3" class="input">
                <label>Fecha final</label>
                <Datepicker
                  @selected="selectDateFinal"
                  :disabled-dates="disableDates"
                  :value="input_date_final.format('MM/DD/YYYY')"
                ></Datepicker>
              </v-col>
              <v-col md="3" cols="12">
                <v-autocomplete
                  label="Departamentos"
                  v-model="selectDep"
                  item-text="Nombre"
                  item-value="id"
                  :items="departamentos"
                ></v-autocomplete>
              </v-col>

              
              <v-col md="3" cols="12">
                <v-text-field
                  v-model="input_folio"
                  label="Folio de Venta"
                ></v-text-field>
              </v-col>
              <v-col md="3" cols="12">
                <v-text-field
                  v-model="input_orden"
                  label="Numero de orden"
                ></v-text-field>
              </v-col>
              <v-col md="3" cols="12">
                <v-switch
                  v-model="totalZero"
                  label="Incluir tickets total 0"
                ></v-switch>
              </v-col>



              <v-col md="12" cols="12">
                <v-btn depressed @click="cleanFilter()" color="error">
                  Restablecer Filtro
                </v-btn>
                <v-btn depressed @click="getVentas()" color="success">
                  Buscar
                </v-btn>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col md="12" cols="12">
        <v-tabs v-model="tab">
          <v-tab>Listado de ventas</v-tab>
        </v-tabs>
        <v-tabs-items v-model="tab">
          <v-tab-item>
            <v-card>
              <v-btn v-if="false" style="right: 250px; position: absolute" color="green" dark
                ><v-icon>mdi-file-excel-box</v-icon>
                <download-excel
                  type="xls"
                  name="Reporte Venta"
                  :data="excelDataFacturacion"
                >
                  Exportar tickets Excel
                </download-excel>
              </v-btn>
              <v-btn
                @click="exportAllTickets()"
                style="right: 0px; position: absolute"
                color="red"
                dark
              >
                Exportar tickets PDF
              </v-btn>

              <v-card-text>
                <v-simple-table class="mt-4">
                  <thead>
                    <tr>
                      <th>Folio</th>
                      <th>Cliente</th>
                      <th>Alias de venta</th>
                      <th>Fecha</th>
                      <th>Caja</th>
                      <th>Cajero</th>
                      <th>Total</th>
                      <th>Cambio</th>
                      <th>Estatus</th>
                      <th>Opciones</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-if="ventas_comp.length == 0">
                      <td colspan="7">No se encontraron datos</td>
                    </tr>
                    <template v-for="(res, index) in ventas_comp">
                      <tr :key="index">
                        <td>{{ res.Folio }}</td>
                        <td>{{ res.Cliente.Nombre }}</td>
                        <td>{{ res.Cliente.Apodo }}</td>
                        <td>{{ res.fecha }}</td>
                        <td>
                          {{res.Caja.nm}}
                        </td>
                        <td>
                          {{res.Cajero.nm}}
                        </td>
                        <td>{{ $pgsHelper.formatNumber(res.Total.C) }} MXN</td>
                        <td>{{ $pgsHelper.formatNumber(res.Cambio.MXN) }}</td>
                        <td>
                          <b
                            v-bind:class="{
                              'orange--text': res.Devos,
                              'green--text': !res.Devos,
                            }"
                            >{{ res.Devos ? "Devolución" : "Activo" }}</b
                          >
                        </td>
                        <td>
                          <v-btn
                            @click="showDetail(res)"
                            color="green"
                            small
                          >
                            Detalles
                          </v-btn>
                          <v-btn
                            @click="printTicket(res)"
                            color="green"
                            small
                          >
                            Ticket
                          </v-btn>
                        </td>
                      </tr>
                    </template>
                  </tbody>
                </v-simple-table>
              </v-card-text>
            </v-card>
          </v-tab-item>
        </v-tabs-items>
      </v-col>
    </v-row>
    <modal v-model="showModal" :showFooter="false" title="Detalle de la venta">
      <resumenVenta :selectedRes="selectedRes" />
    </modal>
  </div>
</template>

<style scoped>

</style>

<script>
import Cliente from "../../../clases/Cliente.js";
import Modificadores from "../../../clases/Modificadores.js";
import Datepicker from "vuejs-datepicker";
import moment from "moment";
import modal from "../../MainComponents/modal.vue";
import resumenVenta from "../../MainComponents/Contabilidad/ResumenVentaConta.vue";
import ticket from "../../../tickets/ticketReprintContabilidad.vue";
import TicketVenta from "../../../clases/TicketVentaContabilidad.js";
import Currencies from "../../../clases/Currencies";
import { mapGetters } from "vuex";
export default {
  name: "ReporteVentas",
  components: {
    Datepicker,
    resumenVenta,
    modal,
  },
  props: ["hideMenu"],
  data() {
    return {
      familias: [],
      selectedProduct: null,
      productsToExclude: [],
      productsToInclude: [],
      totalZero: true,
      keyResume: 0,
      tab: null,
      selectTurno: "ALL",
      aperturas: [],
      input_orden: "",
      loadingData: false,
      showEstad: false,
      input_date: moment(),
      input_date_final: moment(),
      selectedRes: "",
      data_clientes: [],
      input_caja: "",
      selectClient: "",
      input_cajero: "",
      input_folio: "",
      showModal: false,
      formKey: 0,
      data_ventas: [],
      selectedHotel: "",
      hoteles: [],
      Horario: "",
      Horarios: [],
      data_cajas: [],
      reservations: [],
      cashiers: [],
      selectDep: "ALL",
      dataToTicket: {},
    };
  },
  computed: {
    ...mapGetters(["getProductos"]),
    excelDataFacturacion() {
      let tickets = [];
      this.ventas_comp.map(async (venta) => {
        if (venta.Total != 0) {
          if (
            !venta._ProdIdx.includes("MBS-Movimiento") &&
            !venta._ProdIdx.includes("-NMZKJ2fyTWAv4maSf9M") &&
            !venta._ProdIdx.includes("Monedero")
          ) {
            tickets.push({
              Folio: venta.Folio,
              Cliente: venta.Cliente.Nombre,
              Alias: venta.Cliente.Apodo,
              Fecha: venta.fecha,
              Total: venta.Total,
              Cambio: venta.Cambio.MXN,
            });
          }
        }
      });
      return tickets;
    },
    excelData() {
      let tickets = [];
      this.ventas_comp.map(async (venta) => {
        tickets.push({
          Folio: venta.Folio,
          Cliente: venta.Cliente.Nombre,
          Alias: venta.Cliente.Apodo,
          Fecha: venta.fecha,
          Total: venta.Total,
          Cambio: venta.Cambio.MXN,
        });
      });
      return tickets;
    },
    turnosList() {
      let dep = [
        {
          Turno: "ALL",
          Desc: "Todos",
          CajeroName: "Todos",
        },
      ];
      this.aperturas.forEach((de) => {
        dep.push(de);
      });
      return dep;
    },
    getPayMethods() {
      const pagos = {};


      return pagos;
    },
    departamentos() {
      let dep = [
        {
          id: "ALL",
          Nombre: "Todos",
        },
      ];
      let departamentos = this.$store.getters.getPDVDepartamentos;
      departamentos.forEach((de) => {
        dep.push(de);
      });
      return dep;
    },
    ventas_comp() {
      this.data_ventas.forEach((venta) => {
        let totales = 0;
        venta.isVenta = true
        for (const property in venta.Catalogo) {
          let totalProd = 0;
          /*if (venta.Catalogo[property].Modificadores) {
            venta.Catalogo[property].ModificadoresList =
              Modificadores.parseToListOption(
                venta.Catalogo[property].Modificadores
              );
            let totalModi = 0;
            venta.Catalogo[property].ModificadoresList.forEach((modi) => {
              totalModi += modi.pco.C;
            });
            venta.Catalogo[property].totalModi = totalModi;
          }*/
          /*if (venta.Catalogo[property].Pagos) {
            Object.entries(venta.Catalogo[property].Pagos).forEach((pago) => {
              totales += pago[1].def.C;
              if (new moment(venta.FechaCreacion).format("YYYY") == "2023") {
                if (venta.Catalogo[property].STip == "Cuenta") {
                  pago[1].def.C = pago[1].def.C + pago[1].dsc.C * -1;
                  pago[1].dsc.C = 0;
                  venta.Catalogo[property].Descuentos = [];
                }
              }
              totalProd += pago[1].def.C;
            });
          }*/
          venta.Catalogo[property].TotalReal = Number(totalProd);
        }

        venta.sumatoriaTotal = totales;
      });
      let data = this.data_ventas;
      let array = data.sort(function (a, b) {
        if (b.Folio > a.Folio) return -1;
        if (b.Folio < a.Folio) return 1;
      });
      return array;
    },
    selectedReserva() {
      return this.selectedRes;
    },
    disableDates() {
      return { to: new Date(this.input_date) };
    },
    comp_resumen_data() {
      let total_products = 0;
      let total_golf_round = 0;
      let total_proshop = 0;
      let total = 0;
      this.data_ventas.forEach((venta) => {
        let prod = Object.entries(venta.Catalogo);
        this.$pgsHelper.log(prod);
        prod.forEach((producto) => {
          if (producto[0] == "Golf_Round") {
            total_golf_round++;
          } else {
            total_proshop++;
          }
          total_products++;
        });
        total = total + parseInt(venta.Total);
      });
      return {
        total_productos: total_products,
        total_rounds: total_golf_round,
        total_proshop: total_proshop,
        total: total,
      };
    },
    comp_clients() {
      let clientes = [];
      let rowclientes = Cliente.getClientsList();
      rowclientes.forEach((cli) => {
        clientes.push({ value: cli.Id, text: cli.getNombreCompleto() });
      });
      return clientes;
    },
  },
  methods: {
    getName(id) {
      let prod = this.$pgsHelper.getById(this.getProductos, "id", id);
      return prod.Nombre || "Sin nombre";
    },
    addToProductsFilter(type, prod) {
      if (type == "exclude") {
        this.productsToExclude.push({ id: prod, Nombre: this.getName(prod) });
      } else {
        this.productsToInclude.push({ id: prod, Nombre: this.getName(prod) });
      }
    },
    removeProductsFilter(type, id) {
      if (type == "exclude") {
        let filter = this.productsToExclude.filter((prod) => prod.id != id);
        this.productsToExclude = filter;
      } else {
        let filter = this.productsToInclude.filter((prod) => prod.id != id);
        this.productsToInclude = filter;
      }
    },
    async exportAllTickets(sinPrecio) {
      const data =
        await this.$store.getters.getFirebaseApp.database.queryBuilder(
          "PDV/CONF"
        );

      let resultConf = data.val();
      let htmlTickets = "";
      let taskTickets = this.ventas_comp.map(async (venta) => {
        if (venta.Total != 0) {
          if (
            !venta._ProdIdx.includes("MBS-Movimiento") &&
            !venta._ProdIdx.includes("-NMZKJ2fyTWAv4maSf9M") &&
            !venta._ProdIdx.includes("Monedero")
          ) {
            //let tipoCambio = await this.getTipoCambio(venta.TipoCambio);
            venta.TC = 0;
            const dataToTicket = venta;
            dataToTicket.sinPrecio = false;
            dataToTicket.Depto = resultConf[venta.Departamento.id];
            let TVenta = new TicketVenta(dataToTicket);
            TVenta.dataToTicketReprint();
            let ticketHtml = this.$pgsHelper.getHtmlFromComponent(
              this,
              ticket,
              {
                dataToTicket: TVenta,
                currenciDefault:Currencies.getCurrencyDefault()
              }
            );
            htmlTickets += ticketHtml;
          }
        }
      });
      await Promise.all(taskTickets).then((turnos) => {
        this.printMasiveTicket(htmlTickets);
      });
    },
    async printMasiveTicket(ticketHtml) {
      let html = "";
      let cssTicket = await this.$pgsHelper.getTicketCss();
      setTimeout(async () => {
        html += "<html><head><title>" + document.title + "</title>";
        html += "<style>" + cssTicket + "</style>";
        html += "</head><body >";

        html += ticketHtml;
        html += "</body></html>";
        this.$pgsHelper.printTicket(this, html);
      }, 2000);
    },
    async printTicket(res, sinPrecio = false) {
      const data =
        await this.$store.getters.getFirebaseApp.database.queryBuilder(
          "PDV/CONF"
        );
      let Cajero = this.$pgsHelper.getById(this.cashiers,"Id",res.Cajero)
      let resultConf = data.val();
      let cssTicket = await this.$pgsHelper.getTicketCss();
      //let tipoCambio = await this.getTipoCambio(res.TipoCambio);
      res.TC = 0;
      const dataToTicket = res;
      dataToTicket.cajero = { NombreCajero:Cajero.Nomb||"Sin Cajero"}
      dataToTicket.sinPrecio = sinPrecio;
      dataToTicket.Depto = resultConf[res.Departamento.id];
      let TVenta = new TicketVenta(dataToTicket);
      TVenta.dataToTicketReprint();
      let ticketHtml = this.$pgsHelper.getHtmlFromComponent(this, ticket, {
        dataToTicket: TVenta,
        currenciDefault:Currencies.getCurrencyDefault()
      });
      let html = "";
      //let stylesHtml = "";
      setTimeout(async () => {
        /*for (const node of [
          ...document.querySelectorAll('link[rel="stylesheet"], style'),
        ]) {
          stylesHtml += node.outerHTML;
        }*/

        html += "<html><head><title>" + document.title + "</title>";
        html += "<style>" + cssTicket + "</style>";
        //html+= stylesHtml
        html += "</head><body >";

        html += ticketHtml;
        html += "</body></html>";
        /* if (this.$pgsHelper.getConfig("useServerPrinter")) {
          this.$pgsHelper.printerInServerPrinter(
            "<body>" + ticketHtml + "</body>",
            "<style>" + cssTicket + "</style>",
            "TICKET-PRINTER"
          );
        } else {*/
        /*let defaultPreviousPrinter = await this.$pgsHelper.getDefaultPrinter(
            this
          );
          let printer = this.$pgsHelper.getPrinter("tickets");
          if (printer != false) {
            await this.$pgsHelper.usePrinter(printer);
          }*/
        this.$pgsHelper.printTicket(this, html);
        /* }*/
        //this.$pgsHelper.printTicket(this, html,defaultPreviousPrinter);
      }, 2000);
    },

    cleanFilter() {
      (this.input_date = moment()),
        (this.input_date_final = moment()),
        (this.input_folio = "");
      this.selectClient = "";
      this.input_orden = "";
    },
    showDetail(res) {
      this.selectedRes = res;
      if (this.selectedRes) {
        let prod = Object.entries(this.selectedRes.Catalogo);
        this.selectedRes.ListProducts = prod;
        let pag = Object.entries(this.selectedRes.Pagos);
        this.selectedRes.ListPagos = pag;
      } else {
        this.selectedRes.ListProducts = [];
      }
      this.showModal = true;
    },
    selectDate(arg) {
      this.input_date = moment(arg);
      this.input_date_final = moment(arg);
    },
    formatNumber(num) {
      return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
    },
    selectDateFinal(arg) {
      this.input_date_final = moment(arg);
    },
    async getVentas() {
      this.loadingData = true;
      let listVentas = [];
      let data_ventas = [];
			const startDate = this.input_date.format("YYYY-MM-DD");
      const endDate = this.input_date_final.format("YYYY-MM-DD");
      const end = endDate.replace(/.$/, (c) =>
        String.fromCharCode(c.charCodeAt(0) + 1)
      );
      if (this.input_folio != "") {
        const firestore = this.$store.getters.getFirebaseApp.firestore;

        let filter = [
          firestore.where("Folio", "==", this.input_folio),
          firestore.where(
            "Tenant",
            "==",
            this.$store.getters.getFirebaseApp.tenant
          ),
        ];
        const data = await firestore.queryBuilder("PDV_Ventas", filter);
        let preData = [];
        preData = data.docs.map((doc) => {
          listVentas.push({ id: doc.ref.id, ...doc.data() });
          return { id: doc.ref.id, ...doc.data() };
        });
        data_ventas = listVentas;
      } else {
        const firestore = this.$store.getters.getFirebaseApp.firestore;
          let filter = [

            firestore.where(
              "Tenant",
              "==",
              this.$store.getters.getFirebaseApp.tenant
            ),
						firestore.where("Turno.fe", ">=", startDate),
        firestore.where("Turno.fe", "<", end),
          ];

          if (this.selectDep != "ALL" && this.selectDep != "") {
            filter.push(firestore.where("Departamento.id", "==", this.selectDep));
          }


          if (this.input_folio != "") {
            filter.push(firestore.where("Folio", "==", this.input_folio));
          }

          if (this.input_orden != "") {
            filter.push(firestore.where("Orden", "==", this.input_orden));
          }


          const data = await firestore.queryBuilder("PDV_Ventas", filter);
          let preData = [];
          preData = data.docs.map((doc) => {
            listVentas.push({ id: doc.ref.id, ...doc.data() });
            return { id: doc.ref.id, ...doc.data() };
          });
					data_ventas = listVentas;
      }
      let salesToProcessFiltered = [];
      data_ventas.forEach((item) => {
        item.fecha = new moment(item.Turno.fe).format("YYYY-MM-DD");
        let sale = this.filterExcludeProducts(item);
        if (sale) {
          let saleIncludes = this.filterIncludeProducts(item);
          if (saleIncludes) {
            if (!this.totalZero) {
              if (saleIncludes.Total != 0) {
                salesToProcessFiltered.push(saleIncludes);
              }
            } else {
              salesToProcessFiltered.push(saleIncludes);
            }
          }
        }
      });

      this.data_ventas = this.$_.orderBy(
        salesToProcessFiltered,
        "fecha",
        "desc"
      );
      this.showEstad = true;
      this.loadingData = false;
      this.keyResume++;
    },
    filterExcludeProducts(sale) {
      if (this.productsToExclude.length == 0) {
        return sale;
      } else {
        let valid = false;
        this.productsToExclude.forEach((prods) => {
          if (!sale._ProdIdx.includes(prods.id)) {
            valid = true;
          }
        });

        if (valid) {
          return sale;
        } else {
          return false;
        }
      }
    },
    filterIncludeProducts(sale) {
      if (this.productsToInclude.length == 0) {
        return sale;
      } else {
        let valid = false;
        this.productsToInclude.forEach((prods) => {
          if (sale._ProdIdx.includes(prods.id)) {
            valid = true;
          }
        });
        if (valid) {
          return sale;
        } else {
          return false;
        }
      }
    },
  },
  beforeCreate: function () {},
  beforeMount: async function () {
    
  },
};
</script>

<style>
.input input {
  border-bottom: 1px solid black;
  width: 100%;
}
</style>
